<template>
	<nav
		v-if="pageType && pageType != 'home' && pageType != 'cms-page'"
		class="container flex my-4 lg:my-6 whitespace-nowrap"
		aria-label="Breadcrumb"
	>
		<ol class="inline-flex items-center overflow-x-auto pb-2 -mb-2">
			<li class="items-center">
				<NuxtLink
					:to="localePath('/')"
					class="text-black inline-flex items-center text-sm underline"
				>
					{{ $t("Home") }}
				</NuxtLink>
				<span
					class="font-medium ml-2 mr-2 w-5 h-5 text-center text-sm text-gray-500"
					>/
				</span>
			</li>
			<li
				v-for="(crumb, index) in getBreadcrumbs"
				:key="index"
				class="inline items-center"
			>
				<NuxtLink
					v-if="crumb.path && index < getBreadcrumbs.length - 1"
					:to="localePath(crumb.path)"
					class="inline items-center text-sm text-black underline"
				>
					{{ crumb.name }}
				</NuxtLink>
				<span v-else class="inline items-center text-sm text-gray-500">
					{{ crumb.name }}
				</span>
				<span
					v-if="index < getBreadcrumbs.length - 1"
					class="inline font-medium ml-2 mr-2 w-5 h-5 text-center text-sm text-gray-500"
					>/
				</span>
			</li>
		</ol>
	</nav>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import type { BreadcrumbsCategory } from "~/types/composables/useCategoryTypes";

const pageStore = usePageStore();

const { pageTitle, pageType, categoryBreadcrumb } = storeToRefs(pageStore);

const { iterateOverCategoryDetails } = useCategory();
const localePath = useLocalePath();

const getBreadcrumbs = computed(() => {
	const breadcrumbs = [];
	const currentPage = {
		name: pageTitle.value,
		path: ""
	};

	if (
		(pageType.value === "category" || pageType.value === "product") &&
		categoryBreadcrumb
	) {
		let currentCategory:
			| BreadcrumbsCategory
			| Partial<BreadcrumbsCategory>
			| null
			| undefined = JSON.parse(JSON.stringify(categoryBreadcrumb.value));

		while (currentCategory) {
			breadcrumbs.unshift({
				name: currentCategory.Name || "",
				path: `/${iterateOverCategoryDetails(currentCategory)}`
			});
			currentCategory = currentCategory.Parent;
		}

		if (pageType.value === PageSlugs.PRODUCT) {
			breadcrumbs.push(currentPage);
		}
	} else {
		breadcrumbs.push(currentPage);
	}

	return breadcrumbs;
});

// No BreadcrumbList here: every page that renders this (PDP, category, CMS,
// article) emits its own with absolute URLs. A second one shares the
// `#breadcrumb` id, gets merged into it item by item, and — read once at
// setup, before the category trail is known — overwrote "Home" with the
// page title and dropped its URL.
</script>
